import gql from 'graphql-tag';

import DAILY_FRAGMENT from './DAILY_FRAGMENT';

export const GET_SERVICE_RUNS_DAILY = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: ServiceRunPageFilter
	) {
		getServiceRuns(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...serviceRunsDaily
			}
			count
		}
	}
	${DAILY_FRAGMENT}
`;


export default GET_SERVICE_RUNS_DAILY;
